<template>
    <div class="card m-3">
        <div class="card-header">User Feedback</div>
        <form action="">
            <div class="card-body">
                <div class="alert alert-danger" v-show="errMsg !== ''">{{ errMsg }}</div>
                <div class="form-check form-check-inline">
                    <input type="radio" name="userLabelOptions" id="goodRB" class="form-check-input" value="good"
                        v-model="userLabel" required>
                    <label for="goodRB" class="form-check-label">Good</label>
                </div>
                <div class="form-check form-check-inline">
                    <input type="radio" name="userLabelOptions" id="badRB" class="form-check-input" value="bad"
                        v-model="userLabel" required>
                    <label for="badRB" class="form-check-label">Bad</label>
                </div>
                <div class="mt-3 mb-3">
                    <label for="notes" class="form-label">Notes</label>
                    <textarea v-model="userNotes" class="form-control" id="notes" cols="50" rows="3"></textarea>

                </div>
                <div class="row">
                    <div class="col">
                        <button class="btn btn-primary" @click.prevent="saveFeedback">Save Feedback</button>
                    </div>
                </div>
            </div>

        </form>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: ['question', 'semFrame'],
    data() {
        return {
            userNotes: "",
            userLabel: null,
            errMsg: '',
        }
    },
    methods: {
        saveFeedback() {
            const notes = this.userNotes.trim();
            const label = this.userLabel;
            const that = this;
            console.log('label:', label)
            console.log('notes:', notes)
            console.log("semFrame:", this.semFrame)
            console.log("question:", this.question)
            if (!label) {
                this.errMsg = 'At least a label (good/bad) is required as a feedback!'
                return;
            }

            axios.post('/llm_api/user_feedback',
                {
                    'question': that.question, 'sem_frame': that.semFrame,
                    'label': label, 'notes': notes
                }
            ).then(function (response) {
                console.log(response)
                that.$emit('feedbackStatus', {'status': 'ok'});
            }).catch(function (err) {
                console.log(err);
                that.$emit('feedbackStatus', {'status': 'An error occurred during feedback submission.'});
            });

        }
    },
}
</script>

<style scoped></style>